import { AxiosError } from "axios";

interface ApiErrorResponse {
  detail?: string;
  message?: string;
  error?: string;
  [key: string]: unknown;
}

export function getApiErrorMessage(err: unknown): string {
  if (!(err instanceof Error)) return "알 수 없는 오류가 발생했습니다.";

  const axiosErr = err as AxiosError<ApiErrorResponse>;
  const status = axiosErr.response?.status;
  // Axios 응답이 아닌 Error(계약 위반·직렬화 실패 등)는 **자기 message 가 가장 정확하다**.
  // 상태 코드 분기에 흘려보내면 전부 "데이터를 불러오는 중 오류" 로 뭉개져, 관리자가
  // 무엇이 잘못됐는지 알 수 없다. 비-Error 값은 위에서 이미 고정 문구로 걸러진다 —
  // 임의 객체를 문자열로 덤프하면 그 안의 원문이 화면에 실린다.
  if (status === undefined && !axiosErr.isAxiosError && err.message) return err.message;
  const data = axiosErr.response?.data;
  const detail = data?.error ?? data?.detail ?? data?.message;

  switch (status) {
    case 400:
      return detail ?? "잘못된 요청입니다. 입력값을 확인해주세요.";
    case 401:
      return "인증이 만료되었습니다. 다시 로그인해주세요.";
    case 403:
      return detail ?? "접근 권한이 없습니다.";
    case 404:
      return detail ?? "요청한 데이터를 찾을 수 없습니다.";
    case 500:
      return "서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.";
    default:
      return detail ?? "데이터를 불러오는 중 오류가 발생했습니다.";
  }
}

/**
 * API 응답에서 리스트 데이터를 추출합니다.
 * Django REST Framework의 배열 또는 페이지네이션 응답 모두 처리합니다.
 */
export function extractList<T>(data: unknown): T[] {
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object" && "results" in data) {
    return (data as { results: T[] }).results ?? [];
  }
  return [];
}
